import { HttpClient } from 'api/http-client';
export var FeatureStatus = /*#__PURE__*/ function(FeatureStatus) {
    FeatureStatus["TrialPending"] = "TRIAL_PENDING";
    FeatureStatus["InTrial"] = "IN_TRIAL";
    FeatureStatus["TrialExpired"] = "TRIAL_EXPIRED";
    FeatureStatus["Enabled"] = "ENABLED";
    FeatureStatus["Disabled"] = "DISABLED";
    return FeatureStatus;
}({});
class AccountFeatureHttpClient extends HttpClient {
    enableFeature(feature) {
        return this.put(`features/${feature}`);
    }
    disableFeature(feature) {
        return this.delete(`features/${feature}`);
    }
    getFeaturesConfig() {
        return this.get('features/configuration');
    }
}
export const AccountFeatureAPI = new AccountFeatureHttpClient();
